<template>
  <div class="bodys" v-if="body_show">
    <div class="calendar_form">
      <img :src="image_url" alt="" class="poster_img" />
      <div class="sumbit" @click="$router.push({
              path: '/career_calendar',
              query: {
                activity_id: activity_id,
                img_show: true
              }
            })"></div>
      <div class="switch" @click="switch_poster"></div>
    </div>
  </div>
</template>
<script>
import { shengya_activity_poster } from "@/api/other";
import { shareCon } from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        image_url: '',
        activity_id: null,
        poster_ids: [],
        poster_id: '',
        poster_index: 0
      };
    },
    methods: {
      // 换海报
      switch_poster() {
        this.$toast.loading({
          mask: true,
          message: "海报加工中..."
        });
        if(this.poster_index==this.poster_ids.length){
          this.poster_index = 0
        }
        this.poster_id = this.poster_ids[this.poster_index];
        shengya_activity_poster({
          activity_id: this.activity_id,
          poster_id: this.poster_id
        })
          .then(data => {
            this.$toast.clear();
            this.image_url = data.image_url;
            this.poster_index+=1;
          });
      },
      pullData() {
        this.activity_id = this.$route.query.activity_id?this.$route.query.activity_id:5;
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        shengya_activity_poster({
          activity_id: this.activity_id
        })
          .then(data => {
            this.body_show = true;
            this.$toast.clear();
            this.poster_ids = data.poster_ids;
            if(this.poster_ids.length>0){
              this.switch_poster()
            }
          });
      }
    },
    created() {
      this.pullData();
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  text-align: center;
}

.calendar_form {
  width: 100%;
  height: 1334px;
  background: url(../../../../assets/calendar_poster.png) no-repeat top center;
  background-size: cover;
  position: relative;
  z-index: 1;
  img.poster_img {
    position: absolute;
    top: 291px;
    left: 169px;
    width: 414px;
    height: 737px;
  }
  .switch {
    position: absolute;
    top: 1142px;
    left: 401px;
    width: 272px;
    height: 82px;
  }
  .sumbit {
    position: absolute;
    top: 1142px;
    left: 77px;
    width: 272px;
    height: 82px;
  }
}

</style>
